import universal from 'react-universal-component';

export default universal(() => import('./TeamPositionRankings'));



// WEBPACK FOOTER //
// ./src/app/views/TeamPositionRankings/index.js